import { Link } from "react-router-dom";

export default function AboutMe () {
    return (
        <section className="about-me">
            <div className="left">
                <div className="title">about me</div>
                <div className="text">From Concept to Code - I Build and Ship Full Products</div>
                <div>
                    <Link className="btn download-btn btn-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path
                                d="M6.21338 4.33362L7.92005 2.62695L9.62671 4.33362"
                                stroke="#212E42"
                                strokeWidth="1.5"
                                strokeMiterlimit="10"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                            <path
                                d="M7.92004 9.45285V2.67285"
                                stroke="#212E42"
                                strokeWidth="1.5"
                                strokeMiterlimit="10"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                            <path
                                d="M2.66663 8C2.66663 10.9467 4.66663 13.3333 7.99996 13.3333C11.3333 13.3333 13.3333 10.9467 13.3333 8"
                                stroke="#37465C"
                                strokeWidth="1.5"
                                strokeMiterlimit="10"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                            </svg>
                    Downlaod resume
                    </Link>
                </div>
            </div>
            <div className="right">
                Nasir Ahmad Ahamdy, A Full Stack Web Developer Hailing With A Passion For Crafting Seamless Online Experiences, I Delve Into The Intricacies Of Web Development, Ensuring Fast, Responsive, And Intuitive Designs. I Am Dedicated To Pushing The Boundaries Of Web Technology.
            </div>
            <div>
                    <Link className="btn download-btn btn-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path
                                d="M6.21338 4.33362L7.92005 2.62695L9.62671 4.33362"
                                stroke="#212E42"
                                strokeWidth="1.5"
                                strokeMiterlimit="10"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                            <path
                                d="M7.92004 9.45285V2.67285"
                                stroke="#212E42"
                                strokeWidth="1.5"
                                strokeMiterlimit="10"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                            <path
                                d="M2.66663 8C2.66663 10.9467 4.66663 13.3333 7.99996 13.3333C11.3333 13.3333 13.3333 10.9467 13.3333 8"
                                stroke="#37465C"
                                strokeWidth="1.5"
                                strokeMiterlimit="10"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                            </svg>
                    Downlaod resume
                    </Link>
                </div>
        </section>
    )
}